import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import Details from '../../components/Details'

import { FIELDS } from './Form'

const OverlayDetails = () => (
  <Details apiUrl={API_URL} routeName={ROUTE_NAME} fields={FIELDS} />
)

export default OverlayDetails
